module.exports = __webpack_public_path__ + "static/media/profile-image-ab.af08c05d.png";